import HamburgerIcon from '@assets/icons/hamburger.svg';
import React from 'react';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { DRAWER_HEADER_HEIGHT } from '@/styles';
import { DrawerHeader } from './drawer-header';
import { useNavigationDrawerContext } from '@/contexts/navigation-drawer-context';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';
import { View } from 'react-native';

export const DrawerHeaderTablet: React.FC = () => (
  <DrawerHeader DrawerLeftComponent={<DrawerLeftComponentTablet />} />
);

export const DrawerLeftComponentTablet: React.FC = () => {
  const navigationDrawerContext = useNavigationDrawerContext();
  const salesRepMode = useSalesRepMode();
  const [styles, theme] = useStyles();

  return (
    <View
      style={[
        styles.hamburgerWrapper,
        salesRepMode ? styles.hamburgerWrapperDark : null,
      ]}
    >
      <Button
        Icon={HamburgerIcon}
        iconProps={salesRepMode ? { fill: theme.colors.white } : undefined}
        onPress={navigationDrawerContext.openDrawer}
        testID="menu-button"
        trackingData={{
          name: 'drawer_header.open_button',
        }}
        type="tertiary"
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  hamburgerWrapper: {
    height: DRAWER_HEADER_HEIGHT,
    justifyContent: 'center',
    width: 92,
  },
  hamburgerWrapperDark: {
    borderRightColor: theme.colors.white,
  },
}));
